import { createSlice } from '@reduxjs/toolkit';

type initialStateType = {
    open: boolean;
    type: any;
    message: string;
    autoClose: boolean
};

const initialState: initialStateType = {
    open: false,
    type: '',
    message: '',
    autoClose: true
};

const snackbarSlice: any = createSlice({
    name: 'snackbar',
    initialState,
    reducers: {
        showSnackbar: (state, action) => {
            return { ...state, ...action.payload };
        },
        hideSnackbar: (state) => {
            return { ...initialState };
        },
    },
});

export const { showSnackbar, hideSnackbar } = snackbarSlice.actions;
export default snackbarSlice.reducer;
